import { DashboardModule } from '@domain-group/suit-theme'
import OrdersImageUrl from './assets/orders.svg'

const OrdersBlankState = () => (
  <DashboardModule.BlankState boxProps={{ border: 'none' }} imageUrl={OrdersImageUrl}>
    <DashboardModule.BlankState.Title>No Matching Orders</DashboardModule.BlankState.Title>

    <DashboardModule.BlankState.Paragraph>
      You can order from your providers, or create a quote to inform your customer of the costs of a campaign to
      get started.
    </DashboardModule.BlankState.Paragraph>
  </DashboardModule.BlankState>
)
export default OrdersBlankState
